exports.content = `# Support

We value your feedback!

Got questions about hangboard training for climbing?

Please send them to us at [contact-us@hangbird.app](mailto:contact-us@hangbird.app)`
